import { render, staticRenderFns } from "./UpdateSundrySupplierDocumentPopUp.vue?vue&type=template&id=10570022&scoped=true&"
import script from "./UpdateSundrySupplierDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateSundrySupplierDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSundrySupplierDocumentPopUp.vue?vue&type=style&index=0&id=10570022&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10570022",
  null
  
)

export default component.exports